import fp from "lodash/fp";

import { getSideMenuItems } from "components/sideMenu/sideMenuItems";
import { hasPermissions } from "helpers";

export const getFirstAvailableSideMenuLink = () =>
	fp.flow(
		fp.orderBy("redirectPriority", "desc"),
		fp.find<{ [key: string]: any }>(item =>
			hasPermissions(item.requiredPermissions),
		),
	)(getSideMenuItems());
